import svgUrl from "ni:svgr;dqhhgQjlHneY732M777VH9Oq9ezZMhLuqPnR6vF9wJI";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const SourceLIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none" viewBox="0 0 32 32" {...props}><path fill="var(--tbl--colors--icons--source--secondary)" fillRule="evenodd" d="M9 2a4 4 0 0 0-4 4v19a4 4 0 0 0 4 4h9.124A8 8 0 1 1 27 15.755V6a4 4 0 0 0-4-4H9Z" clipRule="evenodd" /><path fill="var(--tbl--colors--icons--source--primary)" fillRule="evenodd" d="M22 30a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm-1-8.586V25a1 1 0 1 0 2 0v-3.586l.293.293a1 1 0 0 0 1.414-1.414l-2-2a1 1 0 0 0-1.414 0l-2 2a1 1 0 0 0 1.414 1.414l.293-.293Z" clipRule="evenodd" /></svg>;
const Memo = memo(SourceLIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "SourceLIcon";
}